export enum PopupNames {
  benifitOfCompletion = "benifitOfCompletion",
}
